module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/beer@2x_68edef.jpg";